export const arrayToString = (array) => {
  let result = `[`;
  // result += array.join(", ");
  array.forEach((item) => {
    if (typeof item === "number") {
      result += `${item}, `;
    } else if (typeof item === "string") {
      result += `"${item}", `;
    } else if (typeof item === "boolean") {
      result += `${item.toString()}, `;
    }
  });
  result = result.substring(0, result.length - 2);
  result += `]`;
  return result;
};

export const getHumanIndex = (array, index) => {
  const length = array.length;
  if (index === 0) {
    return "First";
  }
  if (index === length - 1) {
    return "Last";
  }
  // prettier-ignore
  const humanRedable = [
      "First", "Second", "Third", "Fourth", "Fifth",
      "Sixth", "Seventh", "Eigth", "Ninth", "Tenth",
    ];
  return humanRedable[index];
};
